import { GroupTaskDetailStoreItemComponent } from './group-task-detail-store-item.component';

export const GroupTaskDetailStoreItemModule = angular
  .module('sfMobile.components.groupTaskDetailStoreItem', [])
  .component(
    'sfGroupTaskDetailStoreItem',
    GroupTaskDetailStoreItemComponent
  ).name;
